"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MoreInfoTooltip = void 0;
var _react = require("react");
var _IconLibrary = require("../../packages/IconLibrary");
var _tooltip = _interopRequireDefault(require("../../packages/tooltip"));
var _CTAList = _interopRequireDefault(require("../CTAList"));
var _CloseButton = _interopRequireDefault(require("../CloseButton"));
var _MediaComponent = _interopRequireDefault(require("../MediaComponent"));
var _Text = _interopRequireDefault(require("../Text"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _analytics = _interopRequireWildcard(require("../analytics"));
var _breakpoints = require("../breakpoints");
var _index = _interopRequireDefault(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const MoreInfoContent = function (_ref) {
  let {
    media,
    copy,
    instance,
    brand,
    bindings,
    toyotaIcon,
    lexusIcon,
    ctas,
    additionalAnalytics
  } = _ref;
  const handleOnCloseClick = function (event) {
    event.preventDefault();
    instance.current.hide();
  };
  const closeButtonProps = {};
  if (brand === "toyota") {
    closeButtonProps.brand = brand;
    closeButtonProps.theme = "PrimaryBlack";
    closeButtonProps.disableBackground = true;
    closeButtonProps.size = "16px";
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.MoreInfoContent, {
    "data-testid": "MoreInfoContent",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.CloseButton, {
      onClick: handleOnCloseClick,
      brand: brand,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CloseButton.default, {
        size: "30px",
        ...closeButtonProps,
        toyotaIcon: toyotaIcon,
        lexusIcon: lexusIcon
      })
    }), media && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaComponent.default, {
      StyledImage: _index.default.Image,
      ...media
    }), copy && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.ContentBlock, {
      brand: brand,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default.body, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          bindings: {
            ...bindings,
            handleCloseEvent: handleOnCloseClick
          },
          children: copy
        })
      })
    }), ctas && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.CtaListContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CTAList.default, {
        ctas: ctas,
        additionalAnalytics: additionalAnalytics
      })
    })]
  });
};
const MoreInfoTooltip = function (_ref2) {
  let {
    content,
    children,
    placement = "right",
    maxWidth = 320,
    brand = "",
    style,
    showArrow = false,
    themeName = "",
    hideOnScroll = true,
    bindings,
    appendTo,
    toyotaIcon,
    lexusIcon,
    onClick,
    onShow,
    delay = 0,
    title = "More Info Tooltip",
    shouldCloseOnScroll,
    className,
    infoIcon,
    heading = "",
    additionalAnalytics
  } = _ref2;
  const isMobile = (0, _breakpoints.useMobileBreakpoint)();
  const instance = (0, _react.useRef)();
  const fireAnalytics = (0, _analytics.default)("InfoTooltip");
  const onCreate = function (tippy) {
    instance.current = tippy;
  };
  const handleOnTrigger = function (e) {
    if (typeof onClick === "function") {
      onClick(e);
    }
  };
  const handleOnShow = function (e) {
    var _content$image, _content$image$deskto;
    if (typeof onShow === "function") {
      onShow(e);
    }
    fireAnalytics("open", {
      content: (content === null || content === void 0 ? void 0 : content.copy) || (content === null || content === void 0 ? void 0 : (_content$image = content.image) === null || _content$image === void 0 ? void 0 : (_content$image$deskto = _content$image.desktop) === null || _content$image$deskto === void 0 ? void 0 : _content$image$deskto.alt),
      heading: heading
    });
  };
  const handleOnHide = function () {
    var _content$image2, _content$image2$deskt;
    const {
      reference
    } = instance === null || instance === void 0 ? void 0 : instance.current;
    reference.focus();
    fireAnalytics("close", {
      content: (content === null || content === void 0 ? void 0 : content.copy) || (content === null || content === void 0 ? void 0 : (_content$image2 = content.image) === null || _content$image2 === void 0 ? void 0 : (_content$image2$deskt = _content$image2.desktop) === null || _content$image2$deskt === void 0 ? void 0 : _content$image2$deskt.alt),
      heading: heading
    });
  };
  const onMount = function () {
    const {
      popper
    } = instance === null || instance === void 0 ? void 0 : instance.current;
    const button = popper.querySelector("button");
    button === null || button === void 0 ? void 0 : button.focus();
  };
  const renderChild = children ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.PlainText, {
    style: style,
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.InfoIcon, {
    "aria-label": "Info Tooltip Icon",
    type: "button",
    children: infoIcon ? infoIcon : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLibrary.InfoIcon, {
      style: {
        ...style,
        height: "100%",
        width: "100%"
      },
      title: title
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
    className: className,
    onHide: handleOnHide,
    onShow: handleOnShow,
    onTrigger: handleOnTrigger,
    onCreate: onCreate,
    onMount: onMount,
    placement: placement,
    arrow: showArrow,
    interactive: true,
    appendTo: appendTo ? appendTo : document.body,
    trigger: "click",
    maxWidth: isMobile ? false : maxWidth,
    theme: themeName ? `${themeName}-${brand}` : "MoreInfoContent",
    content: MoreInfoContent({
      ...content,
      instance,
      brand: brand.toLowerCase(),
      bindings,
      toyotaIcon,
      lexusIcon,
      additionalAnalytics
    }),
    role: "dialog",
    "aria-label": "Info Tooltip",
    hideOnScroll: hideOnScroll,
    delay: delay,
    shouldCloseOnScroll: shouldCloseOnScroll,
    "data-testid": "MoreInfoTooltip",
    children: renderChild
  });
};
exports.MoreInfoTooltip = MoreInfoTooltip;
var _default = exports.default = (0, _analytics.withAnalytics)(MoreInfoTooltip)({});